// extracted by mini-css-extract-plugin
export default {"loginBg":"login_loginBg__8jiym","form":"login_form__bsquF"};